// extracted by mini-css-extract-plugin
module.exports = {"form":"submit-your-cv-module--form--33Oju","row":"submit-your-cv-module--row--3TNpC","warning":"submit-your-cv-module--warning---mXRX"};